import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const isFor = ["Estás atravesando una ruptura o cambio importante.", "Sientes que emocionalmente estás agotado.", "Te cuesta dejar de pensar en una persona o situación.", "Sientes que perdiste dirección.", "Quieres reconstruir tu autoestima y seguridad.", "Quieres mejorar la manera en que te relacionas.", "Sabes que necesitas cambiar pero no sabes por dónde comenzar."];
const isNotFor = ["Buscas resultados mágicos.", "Esperas que otra persona cambie por ti.", "No estás dispuesto a participar activamente.", "Necesitas atención psicológica o médica especializada."];
export function ForWhom() {
  return <section className="py-24 md:py-32 bg-ink relative" data-id="element-177" data-mp="3hglttlpyjfm5">
      <div className="container mx-auto px-6" data-id="element-178" data-mp="irmy06t84vof">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto" data-id="element-179" data-mp="isestfezypdn">
          
          {/* IS FOR */}
          <motion.div className="bg-ink-light border border-white/5 p-8 md:p-12 rounded-3xl" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-180" data-mp="dzlq0x339r47">
            <h2 className="text-2xl md:text-3xl font-serif text-ivory-bright mb-8 uppercase" data-id="element-181" data-mp="1fe4y4gws739u">
              ESTE PROCESO PUEDE SER PARA TI SI...
            </h2>
            <ul className="space-y-5" data-id="element-182" data-mp="15g7ds4i1lqmi">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-183" data-mp="1afbj2k1uj47k" data-mpi={index}>
                  <div className="mt-1 bg-gold/10 p-1 rounded-full text-gold shrink-0" data-id="element-184" data-mp="1adh2tj1is09t">
                    <Check className="w-4 h-4" data-id="element-185" data-mp="whn41sugmraf" />
                  </div>
                  <span className="text-ivory/90 font-light leading-relaxed" data-id="element-186" data-mp="11fojm3sog8h5">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* IS NOT FOR */}
          <motion.div className="bg-ink border border-red-900/30 p-8 md:p-12 rounded-3xl flex flex-col" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-187" data-mp="2vrv7o36o6jqv">
            <h2 className="text-2xl md:text-3xl font-serif text-ivory-bright mb-8 uppercase" data-id="element-188" data-mp="2ke39c3u8m48a">
              ESTE PROCESO NO ES PARA TI SI:
            </h2>
            <ul className="space-y-5 mb-10 flex-grow" data-id="element-189" data-mp="3d1z0kt11f3xo">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-190" data-mp="382m73pfnuym4" data-mpi={index}>
                  <div className="mt-1 bg-red-900/30 p-1 rounded-full text-red-400 shrink-0" data-id="element-191" data-mp="385i5fevf7pb3">
                    <X className="w-4 h-4" data-id="element-192" data-mp="33a2scp58lxfq" />
                  </div>
                  <span className="text-muted font-light leading-relaxed" data-id="element-193" data-mp="2ycjbril2h8km">{item}</span>
                </li>)}
            </ul>
            
            <div className="pt-6 border-t border-white/5 text-sm text-muted/80 font-light leading-relaxed space-y-3" data-id="element-194" data-mp="3r29wiah7f8pp">
              <p data-id="element-195" data-mp="28k002xsqgy9">Esta mentoría es un proceso educativo y de acompañamiento personal. No sustituye terapia psicológica, tratamiento médico ni atención profesional de salud mental.</p>
              <p data-id="element-196" data-mp="c67ssnbudeds">Si una persona presenta una situación que requiere atención clínica, debe acudir al profesional correspondiente.</p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>;
}